import { useState, useEffect, useContext, useRef } from 'react';
import PageContext from '../sub-components/PageContext';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
// import AutoCompleteInputWithOptions from '../sub-components/AutoCompleteInputWithOptions';
import { HttpContext } from '../../api-services/HttpService';
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import AdhocDataRow from '../sub-components/AdhocDataRow';
import PageReadOnlyInput from '../sub-components/PageReadOnlyInputCopy.jsx';
// import PageInput from '../sub-components/PageInput';  
import AddAdhocPaymentModal from '../sub-components/AddAdhocPaymentModal.jsx';
import EditAdhocPaymentModal from '../sub-components/EditAdhocPaymentModal.jsx';
// import AdhocCompanySearchRow from '../sub-components/AdhocCompanySearchRow'; 
import ViewSubCompaniesModal from '../sub-components/ViewCompaniesModal';
// import standardSearch from '../functions/standardSearch';
// import applyFilters from '../functions/applyFilters';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import AutoCompleteInputWithOptionsRedux from '../sub-components/AutoCompleteInputWithOptionsRedux';
import MarkPaymentFailedModal from '../sub-components/MarkPaymentFailedModal.jsx';
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx';
import ButtonComponent from '../sub-components/ButtonComponent.jsx';


const AdhocPaymentPage = () => {
    // initialize http context 
    const {
        GET,
    } = useContext(HttpContext);
    // initialize redux persistant state
    const adhocPaymentSearch = useSelector((state) => state.adhocPaymentSearch);
    const dispatch = useDispatch();
    const {
        setAdhocPaymentSearch,
    } = bindActionCreators(actionCreators, dispatch);
    // initialize state for master company autocomplete
    const [masterCompany, setMasterCompany] = useState('--select--');
    const [masterCompanyId, setMasterCompanyId] = useState('--select--');
    const [masterCompanyObj, setMasterCompanyObj] = useState({ label: '--select--', id: '--select--' });
    const [masterCompanyList, setMasterCompanyList] = useState([{ label: '--select--', id: '--select--' }]);
    // initialize table state 
    const [dataList, setDataList] = useState([]);
    const [adhocTableHeader, setAdhocTableHeader] = useState([]);
    // initialize state for spinner
    const [showSpinner, setShowSpinner] = useState(false);
    // initialize state for modal 
    const [showAddAdhocModal, setShowAddAdhocModal] = useState(false);
    const [showEditAdhocModal, setShowEditAdhocModal] = useState(false);
    const [editAdhocRow, setEditAdhocRow] = useState([]);
    const [subCompanyList, setSubCompanyList] = useState([]);
    // initialize state for mark payment as failed modal 
    const [showMarkPaymentFailedModal, setShowMarkPaymentFailedModal] = useState(false);
    const [markPaymentFailedRow, setMarkPaymentFailedRow] = useState({});
    // initialize state for sub company modal
    const [viewModal, setViewModal] = useState(false);
    const [viewCompany, setViewCompany] = useState({});
    // initialize state for entitlement boolean
    const [entitledBool, setEntitledBool] = useState(false);
    // initialize snackbar state
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    // state for true or false 
    const [trueObj, setTrueObj] = useState({label: 'Active', id: "true"});
    const [falseObj, setFalseObj] = useState({label: 'Inactive', id: "false"});
    // initialize input config state
    const [adhocInputConfig, setAdhocInputConfig] = useState([]);
    const [adhocInputLists, setAdhocInputLists] = useState({
        active: [trueObj, falseObj],
        companyid: ['--select--']
    });
    const [enableReset, setEnableReset] = useState(false);

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader) => {
        return (
            <>
                <AdhocDataRow row={row} count={count} tableHeader={tableHeader} editBool={entitledBool} />
            </>
        );
    }

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    // initial get request for masterCompanyList 
    const getMasterCompanyData = () => {
        // show spinner while getting data 
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise((resolve, reject) => {
            GET('/data/adhoc/adhocpage', {}).then(res => {
                // set state for autocomplete
                setMasterCompanyList(masterCompanyList => masterCompanyList = [{ label: '--select--', id: '--select--' } , ...res['data']['MasterCompanyData1']]);
                // set state for table header for adhoc data table
                setAdhocTableHeader(adhocTableHeader => adhocTableHeader = res['data']['AdhocTableCols']);
                // resolve on success and hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                resolve(res);
            }).catch(err => {
                // reject on error and hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        });
    }

    // get payment history once master company has been selected
    const getPaymentHistoryData = () => {
        // show spinner while waiting for response 
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise((resolve, reject) => {
            GET('/data/adhoc/paymenthistory', {
                mastercompanyid: adhocPaymentSearch['id'],
            }).then(res => {
                // set state for datatable
                setDataList(dataList => dataList = res['data']['AdhocTableData']);
                setAdhocTableHeader(adhocTableHeader => adhocTableHeader = res['data']['AdhocTableCols']);
                // set state for input configs 
                setAdhocInputConfig(adhocInputConfig => adhocInputConfig = res['data']['AdhocInputConfig']);
                setAdhocInputLists(adhocInputLists => adhocInputLists = {
                    active: [trueObj, falseObj],
                    companyid: res['data']['SubCompanyList']
                });
                // set state for modal 
                setSubCompanyList(subCompanyList => subCompanyList = res['data']['SubCompanyList']);
                // set state for entitled bool
                setEntitledBool(entitledBool => entitledBool = res['data']['UserEntitlement']);
                // resolve and hide spinner on success
                setShowSpinner(showSpinner => showSpinner = false);
                // resolve on success
                resolve(res);
            }).catch(err => {
                // reject and hide spinner on error
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        });
    }

    // useEffect for initial render
    useEffect(() => {
        // make initial get request 
        getMasterCompanyData().then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    // useEffect when master company changes
    useEffect(() => {
        // only make call if there is a selected company
        if (adhocPaymentSearch['id'] != '--select--') {
            // set masterCompanyId
            setMasterCompanyId(masterCompanyId => masterCompanyId = adhocPaymentSearch['id']);
            setMasterCompanyObj(masterCompanyObj => masterCompanyObj = adhocPaymentSearch);
            // make request to get payment history
            getPaymentHistoryData().then(res => {
                console.log(res);
            }).catch(err => {
                console.log(err);
            });
        }
    }, [adhocPaymentSearch]);

    // variables to pass in page context
    const settings = {
        showAddAdhocModal,
        setShowAddAdhocModal,
        masterCompanyObj,
        setMasterCompanyObj,
        subCompanyList,
        showEditAdhocModal,
        setShowEditAdhocModal,
        editAdhocRow,
        setEditAdhocRow,
        masterCompanyId,
        getPaymentHistoryData,
        viewModal,
        setViewModal,
        viewCompany,
        setViewCompany,
        snackbarAlert,
        showSnackbar,
        snackbarMessage,
        snackbarColor,
        setSnackbarMessage,
        setSnackbarColor,
        setShowSnackbar,
        showMarkPaymentFailedModal,
        setShowMarkPaymentFailedModal,
        markPaymentFailedRow,
        setMarkPaymentFailedRow,
        adhocTableHeader,
        showSpinner,
        adhocInputConfig,
        adhocInputLists
    }

    //reset functionality 
    const resetToDefault = () => {
        setMasterCompany('');
        setMasterCompany('--select--');
        setMasterCompany({ label: '--select--', id: '--select--' })
        setMasterCompany('--select-- --select');
        setMasterCompanyObj({ label: '--select--', id: '--select--' })
        setAdhocPaymentSearch({ label: '--select--', id: '--select--' })
        setEntitledBool(false);
        setDataList([]);
    }

    const enableResetAll = () => {
        if(masterCompanyObj.label !== '--select--'
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [masterCompanyObj])

    return (
        <div class='summary-page'>
            <PageContext.Provider value={settings}>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* modal to add adhoc payment */}
                <AddAdhocPaymentModal refreshFunction={getPaymentHistoryData} />
                <EditAdhocPaymentModal refreshFunction={getPaymentHistoryData} />
                <MarkPaymentFailedModal refreshFunction={getPaymentHistoryData} />
                <ViewSubCompaniesModal />
                {/* snackbar component for alerts */}
                <SnackbarAlert />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        {/* top label with master company autocomplete */}
                        <div className="p-3 mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between flex-wrap'>
                                <div className='d-flex'>
                                    <div className='pe-3'>
                                        {masterCompanyObj['label'] != '--select--' ?
                                            <PageReadOnlyInput tag={process.env.REACT_APP_MASTER_COMPANY_NAME_TAG} value={masterCompanyObj['label']} />
                                            : <PageReadOnlyInput tag={process.env.REACT_APP_MASTER_COMPANY_NAME_TAG} value={''} />}
                                    </div>
                                    <div className='pe-3'>
                                        {masterCompanyObj['id'] != '--select--' ?
                                            <PageReadOnlyInput tag={process.env.REACT_APP_MASTER_COMPANY_ID_TAG} value={masterCompanyObj['id']} />
                                            : <PageReadOnlyInput tag={process.env.REACT_APP_MASTER_COMPANY_ID_TAG} value={''}/>}
                                    </div>
                                    <div className='pe-3'>
                                        <AutoCompleteInputWithOptionsRedux tag={process.env.REACT_APP_MASTER_COMPANY_INFO_TAG} value={masterCompany} setValue={setMasterCompany} obj={adhocPaymentSearch} setObj={setAdhocPaymentSearch} list={masterCompanyList} />
                                    </div>
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableReset ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableReset ? resetToDefault(): null}>
                                        Reset All
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`flex-grow-1 ${dataList.length> 25 ?'': 'pb-3'}`} style={{ borderRadius: '12px', background: '#fff' }}>

                            {entitledBool ?
                                <>
                                <div className="d-flex m-3 align-items-center justify-content-end">
                                    <ButtonComponent tag='Add Adhoc-Payment' onButtonClick={() => setShowAddAdhocModal(showAddAdhocModal => showAddAdhocModal = true)} border={'#3D3D3D 1px solid'} background={'#fff'} color={'#001317'} width='max-content' />
                                    {/* <EntitledButton entitledBool={adhocEditBool} tag='Add Adhoc-Payment' cssClass='table-add-button' onClick={()=>setShowAddAdhocModal(showAddAdhocModal => showAddAdhocModal = true)}/> */}
                                </div>
                                <hr style={{ marginTop: 0 }} />
                                </>
                                : <></>}
                                
                            <OrderedDataTable RowComponent={RowComponent} tableHeader={adhocTableHeader} dataList={dataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' />
                        </div>
                    </div>
                </div>
                {/* data table for payment table */}

                <Footer cssClassName="footer-main-comp" />
            </PageContext.Provider>
        </div>
    );
}

export default AdhocPaymentPage; 